(function(window, localizationStringsFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.localizationStrings = localizationStringsFactory(window.tscme, namespace.languageCodes, namespace.log);
})(this, function(tscme, languageCodes, log) {
   'use strict';

   var _language = languageCodes.ENGLISH;
   var _playerStringsExport = {};
   var _prepositionText = '';

   var playerStrings = {};
   playerStrings.xmpError = {};
   playerStrings.xmpError[languageCodes.ENGLISH] = 'There seems to be a problem accessing certain features of this video. Please contact the video Author.';
   playerStrings.xmpError[languageCodes.GERMAN] = 'Einige Merkmale dieses Videos sind offenbar nicht zugänglich. Bitte setzen Sie sich mit dem Autor des Videos in Verbindung.';
   playerStrings.xmpError[languageCodes.JAPANESE] = 'このビデオの特定機能にアクセスする時に問題が発生したようです。ビデオの作成者に連絡してください。';
   playerStrings.xmpError[languageCodes.FRENCH] = 'Il semblerait qu\'il y ait un problème pour accéder à certaines fonctionnalités de cette vidéo. Veuillez contacter l\'auteur de la vidéo.';
   playerStrings.xmpError[languageCodes.SPANISH] = 'Parece que hay problemas para acceder a determinadas funciones de este vídeo. Póngase en contacto con el autor.';
   playerStrings.xmpError[languageCodes.CHINESE] = '访问此视频的某些功能似乎存在问题。请联系视频作者。';

   playerStrings.xmpSecurity = {};
   playerStrings.xmpSecurity[languageCodes.ENGLISH] = 'Certain features in your video are currently disabled due to Local Network Security. These features work correctly when the video is played from a Website or Server.';
   playerStrings.xmpSecurity[languageCodes.GERMAN] = 'Einige Merkmale Ihrem Video sind zurzeit aufgrund der Sicherheitseinstellungen im lokalen Netzwerk deaktiviert. Diese Merkmale funktionieren wie vorgesehen, wenn das Video über eine Website oder einen Server wiedergegeben wird.';
   playerStrings.xmpSecurity[languageCodes.JAPANESE] = 'ローカル ネットワークのセキュリティのために、ビデオの特定機能が現在無効になっています。これらの機能は、Web サイトまたはサーバーからビデオを再生すると正しく動作します。';
   playerStrings.xmpSecurity[languageCodes.FRENCH] = 'Certaines fonctionnalités de votre vidéo sont actuellement désactivées pour des raisons de sécurité du réseau local. Elles fonctionnent correctement lorsque la vidéo est lue à partir d\'un site Web ou d\'un serveur.';
   playerStrings.xmpSecurity[languageCodes.SPANISH] = 'Actualmente determinadas funciones del vídeo están desactivadas debido a la configuración de seguridad de la red local. Funcionarán correctamente cuando el vídeo se reproduzca desde un sitio web o un servidor.';
   playerStrings.xmpSecurity[languageCodes.CHINESE] = '由于本地网络安全，您视频中的某些功能当前已被禁用。从网站或服务器播放此视频时，这些功能正常工作。';

   playerStrings.videoNotSupported = {};
   playerStrings.videoNotSupported[languageCodes.ENGLISH] = 'Your browser cannot play this video.';
   playerStrings.videoNotSupported[languageCodes.GERMAN] = 'Ihr Browser kann dieses Video nicht wiedergeben.';
   playerStrings.videoNotSupported[languageCodes.JAPANESE] = 'お使いのブラウザではこのビデオを再生できません。';
   playerStrings.videoNotSupported[languageCodes.FRENCH] = 'Votre navigateur ne peut pas lire cette vidéo.';
   playerStrings.videoNotSupported[languageCodes.SPANISH] = 'Su explorador no puede reproducir este vídeo.';
   playerStrings.videoNotSupported[languageCodes.CHINESE] = '您的浏览器无法播放此视频。';

   playerStrings.noWebMSupport = {};
   playerStrings.noWebMSupport[languageCodes.ENGLISH] = 'This browser does not support WebM video.';
   playerStrings.noWebMSupport[languageCodes.GERMAN] = 'Dieser Browser bietet keine WebM-Video-Unterstützung.';
   playerStrings.noWebMSupport[languageCodes.JAPANESE] = 'このブラウザは WebM ビデオをサポートしていません。';
   playerStrings.noWebMSupport[languageCodes.FRENCH] = 'Ce navigateur ne prend pas en charge la vidéo WebM.';
   playerStrings.noWebMSupport[languageCodes.SPANISH] = 'Este explorador no admite vídeo WebM.';
   playerStrings.noWebMSupport[languageCodes.CHINESE] = '此浏览器不支持 WebM 视频。';

   playerStrings.search = {};
   playerStrings.search[languageCodes.ENGLISH] = 'Search';
   playerStrings.search[languageCodes.GERMAN] = 'Suchen';
   playerStrings.search[languageCodes.JAPANESE] = '検索';
   playerStrings.search[languageCodes.FRENCH] = 'Rechercher';
   playerStrings.search[languageCodes.SPANISH] = 'Buscar';
   playerStrings.search[languageCodes.CHINESE] = '搜索';

   playerStrings.searchPlaceholder = {};
   playerStrings.searchPlaceholder[languageCodes.ENGLISH] = 'Search...';
   playerStrings.searchPlaceholder[languageCodes.GERMAN] = 'Suchen...';
   playerStrings.searchPlaceholder[languageCodes.JAPANESE] = '検索...';
   playerStrings.searchPlaceholder[languageCodes.FRENCH] = 'Rechercher...';
   playerStrings.searchPlaceholder[languageCodes.SPANISH] = 'Buscar...';
   playerStrings.searchPlaceholder[languageCodes.CHINESE] = '搜索...';

   playerStrings.playerRateText = {};
   playerStrings.playerRateText[languageCodes.ENGLISH] = 'Playback Speed';
   playerStrings.playerRateText[languageCodes.GERMAN] = 'Wiedergabe-Geschwindigkeit';
   playerStrings.playerRateText[languageCodes.JAPANESE] = '再生速度';
   playerStrings.playerRateText[languageCodes.FRENCH] = 'Vitesse de lecture';
   playerStrings.playerRateText[languageCodes.SPANISH] = 'Velocidad de reproducción';
   playerStrings.playerRateText[languageCodes.CHINESE] = '播放速度';

   playerStrings.playerRateOptionsText = {};
   playerStrings.playerRateOptionsText[languageCodes.ENGLISH] = {
      0.25: '0.25',
      0.5: '0.5',
      0.75: '0.75',
      1: 'normal',
      1.25: '1.25',
      1.5: '1.5',
      1.75: '1.75',
      2.0: '2.0'
   };
   playerStrings.playerRateOptionsText[languageCodes.GERMAN] = {
      0.25: '0.25',
      0.5: '0.5',
      0.75: '0.75',
      1: 'normal',
      1.25: '1.25',
      1.5: '1.5',
      1.75: '1.75',
      2.0: '2.0'
   };
   playerStrings.playerRateOptionsText[languageCodes.JAPANESE] = {
      0.25: '0.25',
      0.5: '0.5',
      0.75: '0.75',
      1: '標準',
      1.25: '1.25',
      1.5: '1.5',
      1.75: '1.75',
      2.0: '2.0'
   };
   playerStrings.playerRateOptionsText[languageCodes.FRENCH] = {
      0.25: '0,25',
      0.5: '0,5',
      0.75: '0,75',
      1: 'normale',
      1.25: '1,25',
      1.5: '1,5',
      1.75: '1,75',
      2.0: '2,0'
   };
   playerStrings.playerRateOptionsText[languageCodes.SPANISH] = {
      0.25: '0,25',
      0.5: '0,5',
      0.75: '0,75',
      1: 'normal',
      1.25: '1,25',
      1.5: '1,5',
      1.75: '1,75',
      2.0: '2,0'
   };
   playerStrings.playerRateOptionsText[languageCodes.CHINESE] = {
      0.25: '0.25',
      0.5: '0.5',
      0.75: '0.75',
      1: '正常',
      1.25: '1.25',
      1.5: '1.5',
      1.75: '1.75',
      2.0: '2.0'
   };

   playerStrings.ccLanguageText = {};
   playerStrings.ccLanguageText[languageCodes.ENGLISH] = 'Closed Captions';
   playerStrings.ccLanguageText[languageCodes.GERMAN] = 'Geschlossene Untertitel';
   playerStrings.ccLanguageText[languageCodes.JAPANESE] = 'クローズド キャプション';
   playerStrings.ccLanguageText[languageCodes.FRENCH] = 'Sous-titres activables';
   playerStrings.ccLanguageText[languageCodes.SPANISH] = 'Subtítulos';
   playerStrings.ccLanguageText[languageCodes.CHINESE] = '隐藏式字幕';

   playerStrings.searchDisabledFullScreen = {};
   playerStrings.searchDisabledFullScreen[languageCodes.ENGLISH] = 'Search is disabled in fullscreen mode.';
   playerStrings.searchDisabledFullScreen[languageCodes.GERMAN] = 'Die Suche ist im Vollbildmodus deaktiviert.';
   playerStrings.searchDisabledFullScreen[languageCodes.JAPANESE] = 'フル画面モードでは検索機能は無効です。';
   playerStrings.searchDisabledFullScreen[languageCodes.FRENCH] = 'La recherche est désactivée en mode Plein écran.';
   playerStrings.searchDisabledFullScreen[languageCodes.SPANISH] = 'La función Buscar está desactivada en el modo de pantalla completa.';
   playerStrings.searchDisabledFullScreen[languageCodes.CHINESE] = '搜索在全屏模式下被禁用。';

   playerStrings.mediaNotFound = {};
   playerStrings.mediaNotFound[languageCodes.ENGLISH] = 'We\'re sorry, but we are unable to connect to this content. Please try refreshing the page or <a href=\'https://www.techsmith.com/redirect.asp?target=media_not_found&ver=4.*.*&lang=enu&os=na&product=smartplayer\' target=\'_blank\'> click here for more help.</a>';
   playerStrings.mediaNotFound[languageCodes.GERMAN] = 'Leider können wir im Moment keine Verbindung zu diesen Inhalten herstellen. Bitte versuchen Sie die Seite neu zu laden oder <a href=\'https://www.techsmith.com/redirect.asp?target=media_not_found&ver=4.*.*&lang=deu&os=na&product=smartplayer\' target=\'_blank\'>klicken Sie hier für weitere Hilfe.</a>';
   playerStrings.mediaNotFound[languageCodes.JAPANESE] = '申し訳ありません。このコンテンツに接続できません。ページを再読み込みするか、<a href=\'https://www.techsmith.com/redirect.asp?target=media_not_found&ver=4.*.*&lang=jpn&os=na&product=smartplayer\' target=\'_blank\'>ここをクリックしてヘルプをご参照ください。</a>';
   playerStrings.mediaNotFound[languageCodes.FRENCH] = 'Nous sommes désolés, nous n\'avons pas pu établir de connexion avec ce contenu. Essayez d\'actualiser la page ou <a href=\'https://www.techsmith.com/redirect.asp?target=media_not_found&ver=4.*.*&lang=enu&os=na&product=smartplayer\' target=\'_blank\'>cliquez ici pour obtenir de l\'aide.</a>';
   playerStrings.mediaNotFound[languageCodes.SPANISH] = 'Lo lamentamos, pero no hemos podido conectarnos a este contenido. Pruebe a actualizar la página o <a href=\'https://www.techsmith.com/redirect.asp?target=media_not_found&ver=4.*.*&lang=enu&os=na&product=smartplayer\' target=\'_blank\'> pulse aquí para obtener ayuda.</a>';
   playerStrings.mediaNotFound[languageCodes.CHINESE] = '很抱歉，我们无法连接到此内容。请尝试刷新页面或<a href= \'https://www.techsmith.com/redirect.asp?target=media_not_found&ver=4.*.*&lang=enu&os=na&product=smartplayer \' target= \'_blank \'>单击此处获取更多帮助。</a>';

   playerStrings.videoLoading = {};
   playerStrings.videoLoading[languageCodes.ENGLISH] = 'The video is loading.';
   playerStrings.videoLoading[languageCodes.GERMAN] = 'Das Video wird geladen.';
   playerStrings.videoLoading[languageCodes.JAPANESE] = 'ビデオを読み込んでいます。';
   playerStrings.videoLoading[languageCodes.FRENCH] = 'La vidéo est en cours de chargement.';
   playerStrings.videoLoading[languageCodes.SPANISH] = 'El vídeo se está cargando.';
   playerStrings.videoLoading[languageCodes.CHINESE] = '视频正在加载';

   playerStrings.close = {};
   playerStrings.close[languageCodes.ENGLISH] = 'Close';
   playerStrings.close[languageCodes.GERMAN] = 'Schließen';
   playerStrings.close[languageCodes.JAPANESE] = '閉じる';
   playerStrings.close[languageCodes.FRENCH] = 'Fermer';
   playerStrings.close[languageCodes.SPANISH] = 'Cerrar';
   playerStrings.close[languageCodes.CHINESE] = '关闭';

   playerStrings.playWithSmartPlayer = {};
   playerStrings.playWithSmartPlayer[languageCodes.ENGLISH] = 'Play with TechSmith Smart Player';
   playerStrings.playWithSmartPlayer[languageCodes.GERMAN] = 'Mit TechSmith Smart Player abspielen';
   playerStrings.playWithSmartPlayer[languageCodes.JAPANESE] = 'クリックして終了';
   playerStrings.playWithSmartPlayer[languageCodes.FRENCH] = 'Lire avec TechSmith Smart Player';
   playerStrings.playWithSmartPlayer[languageCodes.SPANISH] = 'Reproducir con TechSmith Smart Player';
   playerStrings.playWithSmartPlayer[languageCodes.CHINESE] = '用 TechSmith Smart Player 播放';

   playerStrings.playVideoOnly = {};
   playerStrings.playVideoOnly[languageCodes.ENGLISH] = 'Play Video Only';
   playerStrings.playVideoOnly[languageCodes.GERMAN] = 'Nur Video wiedergeben';
   playerStrings.playVideoOnly[languageCodes.JAPANESE] = 'ビデオの再生のみ';
   playerStrings.playVideoOnly[languageCodes.FRENCH] = 'Lire la vidéo uniquement';
   playerStrings.playVideoOnly[languageCodes.SPANISH] = 'Reproducir solo el vídeo';
   playerStrings.playVideoOnly[languageCodes.CHINESE] = '仅播放视频';

   playerStrings.openWithSmartPlayer = {};
   playerStrings.openWithSmartPlayer[languageCodes.ENGLISH] = 'Open video in TechSmith Smart Player';
   playerStrings.openWithSmartPlayer[languageCodes.GERMAN] = 'Öffnen Sie das Video im TechSmith Smart Player.';
   playerStrings.openWithSmartPlayer[languageCodes.JAPANESE] = 'TechSmith Smart Player でビデオを開く';
   playerStrings.openWithSmartPlayer[languageCodes.FRENCH] = 'Ouvrir la vidéo dans TechSmith Smart Player';
   playerStrings.openWithSmartPlayer[languageCodes.SPANISH] = 'Abrir vídeo en TechSmith Smart Player';
   playerStrings.openWithSmartPlayer[languageCodes.CHINESE] = '在 TechSmith Smart Player 中打开视频';

   playerStrings.openSmartPlayerAppStore = {};
   playerStrings.openSmartPlayerAppStore[languageCodes.ENGLISH] = 'Get TechSmith Smart Player for iOS';
   playerStrings.openSmartPlayerAppStore[languageCodes.GERMAN] = 'TechSmith Smart Player für iOS';
   playerStrings.openSmartPlayerAppStore[languageCodes.JAPANESE] = 'TechSmith Smart Player for iOS を入手';
   playerStrings.openSmartPlayerAppStore[languageCodes.FRENCH] = 'Télécharger TechSmith Smart Player pour iOS';
   playerStrings.openSmartPlayerAppStore[languageCodes.SPANISH] = 'Obtener TechSmith Smart Player para iOS';
   playerStrings.openSmartPlayerAppStore[languageCodes.CHINESE] = '获得 TechSmith Smart Player for iOS';

   // quizzing UI --------------------------------------------------------------------------------
   playerStrings.txtRequiredMessage = {};
   playerStrings.txtRequiredMessage[languageCodes.ENGLISH] = 'A first name, last name, and email address are required to continue.';
   playerStrings.txtRequiredMessage[languageCodes.GERMAN] = 'Geben Sie einen Vornamen, einen Nachnamen und eine E-Mail-Adresse an, um fortzufahren.';
   playerStrings.txtRequiredMessage[languageCodes.JAPANESE] = '操作を続けるには、名、姓、およびメール アドレスを必ず入力してください。';
   playerStrings.txtRequiredMessage[languageCodes.FRENCH] = 'Vous devez saisir un prénom, un nom et une adresse e-mail pour continuer.';
   playerStrings.txtRequiredMessage[languageCodes.SPANISH] = 'Debe facilitar su nombre, sus apellidos y una dirección de correo electrónico para poder continuar.';
   playerStrings.txtRequiredMessage[languageCodes.CHINESE] = '要继续使用名字、姓氏和电子邮件地址。';

   playerStrings.txtSkip = {};
   playerStrings.txtSkip[languageCodes.ENGLISH] = 'Continue without Questions';
   playerStrings.txtSkip[languageCodes.GERMAN] = 'Ohne Fragen fortfahren';
   playerStrings.txtSkip[languageCodes.JAPANESE] = '質問を入力せずに続行';
   playerStrings.txtSkip[languageCodes.FRENCH] = 'Continuer sans les questions';
   playerStrings.txtSkip[languageCodes.SPANISH] = 'Continuar sin preguntas';
   playerStrings.txtSkip[languageCodes.CHINESE] = '没有问题的情况下继续';

   playerStrings.txtBegin = {};
   playerStrings.txtBegin[languageCodes.ENGLISH] = 'Submit and Continue';
   playerStrings.txtBegin[languageCodes.GERMAN] = 'Abschicken und fortfahren';
   playerStrings.txtBegin[languageCodes.JAPANESE] = '送信して続行';
   playerStrings.txtBegin[languageCodes.FRENCH] = 'Envoyer et continuer';
   playerStrings.txtBegin[languageCodes.SPANISH] = 'Enviar y continuar';
   playerStrings.txtBegin[languageCodes.CHINESE] = '提交并继续';

   playerStrings.txtEnterFirstName = {};
   playerStrings.txtEnterFirstName[languageCodes.ENGLISH] = 'Enter first name';
   playerStrings.txtEnterFirstName[languageCodes.GERMAN] = 'Bitte Vornamen eingeben';
   playerStrings.txtEnterFirstName[languageCodes.JAPANESE] = '名を入力してください';
   playerStrings.txtEnterFirstName[languageCodes.FRENCH] = 'Saisir le prénom';
   playerStrings.txtEnterFirstName[languageCodes.SPANISH] = 'Introduzca su nombre';
   playerStrings.txtEnterFirstName[languageCodes.CHINESE] = '输入名字';

   playerStrings.txtEnterLastName = {};
   playerStrings.txtEnterLastName[languageCodes.ENGLISH] = 'Enter last name';
   playerStrings.txtEnterLastName[languageCodes.GERMAN] = 'Bitte Nachnamen eingeben';
   playerStrings.txtEnterLastName[languageCodes.JAPANESE] = '姓を入力してください';
   playerStrings.txtEnterLastName[languageCodes.FRENCH] = 'Saisir le nom';
   playerStrings.txtEnterLastName[languageCodes.SPANISH] = 'Introduzca sus apellidos';
   playerStrings.txtEnterLastName[languageCodes.CHINESE] = '输入姓氏';

   playerStrings.txtEnterEmail = {};
   playerStrings.txtEnterEmail[languageCodes.ENGLISH] = 'Enter email address';
   playerStrings.txtEnterEmail[languageCodes.GERMAN] = 'Bitte E-Mail Adresse eingeben';
   playerStrings.txtEnterEmail[languageCodes.JAPANESE] = 'メールアドレスを入力してください';
   playerStrings.txtEnterEmail[languageCodes.FRENCH] = 'Saisir l\'adresse e-mail';
   playerStrings.txtEnterEmail[languageCodes.SPANISH] = 'Introduzca su dirección de correo electrónico';
   playerStrings.txtEnterEmail[languageCodes.CHINESE] = '输入电子邮件地址';

   playerStrings.txtHotspot = {};
   playerStrings.txtHotspot[languageCodes.ENGLISH] = 'Hotspot';
   playerStrings.txtHotspot[languageCodes.GERMAN] = 'Hotspot';
   playerStrings.txtHotspot[languageCodes.JAPANESE] = 'ホットスポット';
   playerStrings.txtHotspot[languageCodes.FRENCH] = 'Zone dynamique';
   playerStrings.txtHotspot[languageCodes.SPANISH] = 'Zona activa';
   playerStrings.txtHotspot[languageCodes.CHINESE] = '热点';

   playerStrings.txtHotspotScreenReaderAlert = {};
   playerStrings.txtHotspotScreenReaderAlert[languageCodes.ENGLISH] = '{{numberOfHotspots}} new Hotspot';
   playerStrings.txtHotspotScreenReaderAlert[languageCodes.GERMAN] = '{{numberOfHotspots}} neuer Hotspot';
   playerStrings.txtHotspotScreenReaderAlert[languageCodes.JAPANESE] = '{{numberOfHotspots}} 個の新しいホットスポット';
   playerStrings.txtHotspotScreenReaderAlert[languageCodes.FRENCH] = '{{numberOfHotspots}} nouvelle zone interactive';
   playerStrings.txtHotspotScreenReaderAlert[languageCodes.SPANISH] = '{{numberOfHotspots}} zona activa nueva';
   playerStrings.txtHotspotScreenReaderAlert[languageCodes.CHINESE] = '{{numberOfHotspots}}新热点';

   playerStrings.txtHotspotScreenReaderAlertPlural = {};
   playerStrings.txtHotspotScreenReaderAlertPlural[languageCodes.ENGLISH] = '{{numberOfHotspots}} new Hotspots';
   playerStrings.txtHotspotScreenReaderAlertPlural[languageCodes.GERMAN] = '{{numberOfHotspots}} neue Hotspots';
   playerStrings.txtHotspotScreenReaderAlertPlural[languageCodes.JAPANESE] = '{{numberOfHotspots}} 個の新しいホットスポット';
   playerStrings.txtHotspotScreenReaderAlertPlural[languageCodes.FRENCH] = '{{numberOfHotspots}} nouvelles zones interactives';
   playerStrings.txtHotspotScreenReaderAlertPlural[languageCodes.SPANISH] = '{{numberOfHotspots}} zonas activas nuevas';
   playerStrings.txtHotspotScreenReaderAlertPlural[languageCodes.CHINESE] = '{{numberOfHotspots}}新热点';

   playerStrings.txtJumpToMedia = {};
   playerStrings.txtJumpToMedia[languageCodes.ENGLISH] = 'Jump to media';
   playerStrings.txtJumpToMedia[languageCodes.GERMAN] = 'Zu Medien springen';
   playerStrings.txtJumpToMedia[languageCodes.JAPANESE] = 'メディアへジャンプ';
   playerStrings.txtJumpToMedia[languageCodes.FRENCH] = 'Atteindre un élément multimédia';
   playerStrings.txtJumpToMedia[languageCodes.SPANISH] = 'Saltar al medio';
   playerStrings.txtJumpToMedia[languageCodes.CHINESE] = '跳转到媒体';

   playerStrings.txtJumpToTime = {};
   playerStrings.txtJumpToTime[languageCodes.ENGLISH] = 'Jump to time';
   playerStrings.txtJumpToTime[languageCodes.GERMAN] = 'Zu Zeitpunkt springen';
   playerStrings.txtJumpToTime[languageCodes.JAPANESE] = '時間へジャンプ';
   playerStrings.txtJumpToTime[languageCodes.FRENCH] = 'Atteindre une heure';
   playerStrings.txtJumpToTime[languageCodes.SPANISH] = 'Saltar al tiempo';
   playerStrings.txtJumpToTime[languageCodes.CHINESE] = '跳转到时间';

   playerStrings.txtOpenLink = {};
   playerStrings.txtOpenLink[languageCodes.ENGLISH] = 'Open link';
   playerStrings.txtOpenLink[languageCodes.GERMAN] = 'Link öffnen';
   playerStrings.txtOpenLink[languageCodes.JAPANESE] = 'リンクを開く';
   playerStrings.txtOpenLink[languageCodes.FRENCH] = 'Ouvrir le lien';
   playerStrings.txtOpenLink[languageCodes.SPANISH] = 'Abrir vínculo';
   playerStrings.txtOpenLink[languageCodes.CHINESE] = '打开链接';

   playerStrings.txtReview = {};
   playerStrings.txtReview[languageCodes.ENGLISH] = 'Replay Last Section';
   playerStrings.txtReview[languageCodes.GERMAN] = 'Letzten Abschnitt erneut wiedergeben';
   playerStrings.txtReview[languageCodes.JAPANESE] = '最後に選択した範囲をもう一度再生';
   playerStrings.txtReview[languageCodes.FRENCH] = 'Revoir la dernière section';
   playerStrings.txtReview[languageCodes.SPANISH] = 'Reproducir última sección';
   playerStrings.txtReview[languageCodes.CHINESE] = '重播最后一部分';

   playerStrings.txtAnswerQuestion = {};
   playerStrings.txtAnswerQuestion[languageCodes.ENGLISH] = 'Take Quiz Now';
   playerStrings.txtAnswerQuestion[languageCodes.GERMAN] = 'Jetzt am Quiz teilnehmen';
   playerStrings.txtAnswerQuestion[languageCodes.JAPANESE] = '今すぐクイズに解答する';
   playerStrings.txtAnswerQuestion[languageCodes.FRENCH] = 'Répondre au questionnaire';
   playerStrings.txtAnswerQuestion[languageCodes.SPANISH] = 'Responder al cuestionario ahora';
   playerStrings.txtAnswerQuestion[languageCodes.CHINESE] = '立即进行测验';

   playerStrings.txtPrev = {};
   playerStrings.txtPrev[languageCodes.ENGLISH] = 'Previous';
   playerStrings.txtPrev[languageCodes.GERMAN] = 'Zurück';
   playerStrings.txtPrev[languageCodes.JAPANESE] = '前へ';
   playerStrings.txtPrev[languageCodes.FRENCH] = 'Précédent';
   playerStrings.txtPrev[languageCodes.SPANISH] = 'Anterior';
   playerStrings.txtPrev[languageCodes.CHINESE] = '上一个';

   playerStrings.txtNext = {};
   playerStrings.txtNext[languageCodes.ENGLISH] = 'Next';
   playerStrings.txtNext[languageCodes.GERMAN] = 'Weiter';
   playerStrings.txtNext[languageCodes.JAPANESE] = '次へ';
   playerStrings.txtNext[languageCodes.FRENCH] = 'Suivant';
   playerStrings.txtNext[languageCodes.SPANISH] = 'Siguiente';
   playerStrings.txtNext[languageCodes.CHINESE] = '下一个';

   playerStrings.txtSubmit = {};
   playerStrings.txtSubmit[languageCodes.ENGLISH] = 'Submit Answers';
   playerStrings.txtSubmit[languageCodes.GERMAN] = 'Antworten abschicken';
   playerStrings.txtSubmit[languageCodes.JAPANESE] = '解答・回答の送信';
   playerStrings.txtSubmit[languageCodes.FRENCH] = 'Envoyer les réponses';
   playerStrings.txtSubmit[languageCodes.SPANISH] = 'Enviar respuestas';
   playerStrings.txtSubmit[languageCodes.CHINESE] = '提交答案';

   playerStrings.txtSubmittingAnswers = {};
   playerStrings.txtSubmittingAnswers[languageCodes.ENGLISH] = 'Submitting answers.';
   playerStrings.txtSubmittingAnswers[languageCodes.GERMAN] = 'Antwort wird gesendet.';
   playerStrings.txtSubmittingAnswers[languageCodes.JAPANESE] = '回答を送信中です。';
   playerStrings.txtSubmittingAnswers[languageCodes.FRENCH] = 'Envoi des réponses en cours.';
   playerStrings.txtSubmittingAnswers[languageCodes.SPANISH] = 'Enviando respuestas.';
   playerStrings.txtSubmittingAnswers[languageCodes.CHINESE] = '正在提交答案。';

   playerStrings.txtContinue = {};
   playerStrings.txtContinue[languageCodes.ENGLISH] = 'Continue';
   playerStrings.txtContinue[languageCodes.GERMAN] = 'Fortsetzen';
   playerStrings.txtContinue[languageCodes.JAPANESE] = '続行';
   playerStrings.txtContinue[languageCodes.FRENCH] = 'Continuer';
   playerStrings.txtContinue[languageCodes.SPANISH] = 'Continuar';
   playerStrings.txtContinue[languageCodes.CHINESE] = '继续';

   playerStrings.txtReviewAnswer = {};
   playerStrings.txtReviewAnswer[languageCodes.ENGLISH] = 'View Answers';
   playerStrings.txtReviewAnswer[languageCodes.GERMAN] = 'Antworten anzeigen';
   playerStrings.txtReviewAnswer[languageCodes.JAPANESE] = '解答・回答を表示';
   playerStrings.txtReviewAnswer[languageCodes.FRENCH] = 'Afficher les réponses';
   playerStrings.txtReviewAnswer[languageCodes.SPANISH] = 'Ver respuestas';
   playerStrings.txtReviewAnswer[languageCodes.CHINESE] = '查看答案';

   playerStrings.txtBadImageQuiz = {};
   playerStrings.txtBadImageQuiz[languageCodes.ENGLISH] = 'We\'re sorry, the requested quiz is not compatible with images and could not be loaded.  Please contact the author of this quiz.';
   playerStrings.txtBadImageQuiz[languageCodes.GERMAN] = 'Leider ist das angeforderte Quiz nicht kompatibel mit Bildern und konnte nicht geladen werden. Bitte kontaktieren Sie den Autor.';
   playerStrings.txtBadImageQuiz[languageCodes.JAPANESE] = '申し訳ありません。このクイズは画像と互換性がなくロードできませんでした。このクイズの作成者にお問い合わせください。';
   playerStrings.txtBadImageQuiz[languageCodes.FRENCH] = 'Nous sommes désolés, le questionnaire demandé étant incompatible avec les images, il ne peut pas être chargé. Veuillez contacter l\'auteur de ce questionnaire.';
   playerStrings.txtBadImageQuiz[languageCodes.SPANISH] = 'Lo lamentamos, el cuestionario solicitado no admite imágenes y no se puede cargar. Póngase en contacto con el autor de este cuestionario.';
   playerStrings.txtBadImageQuiz[languageCodes.CHINESE] = '很抱歉，请求的测验与图片不兼容，无法加载。请联系本测验的作者。';

   playerStrings.txtVideoQuizNetworkErrorMessage = {};
   playerStrings.txtVideoQuizNetworkErrorMessage[languageCodes.ENGLISH] = 'We\'re sorry, a network error has prevented the quiz from loading. The video is available to view. To try and reload the quiz, refresh the browser page or check your network connection.';
   playerStrings.txtVideoQuizNetworkErrorMessage[languageCodes.GERMAN] = 'Das Quiz konnte aufgrund eines Netzwerkfehlers nicht geladen werden. Das Video steht zur Ansicht bereit. Sie können versuchen das Quiz erneut zu laden, indem Sie die Browserseite aktualisieren bzw. Ihre Netzwerkverbindung überprüfen.';
   playerStrings.txtVideoQuizNetworkErrorMessage[languageCodes.JAPANESE] = '申し訳ありませんが、ネットワーク エラーによりクイズを読み込めませんでした。ビデオは表示できます。クイズを再度読み込むには、ブラウザのページを更新するか、ネットワーク接続を確認してください。';
   playerStrings.txtVideoQuizNetworkErrorMessage[languageCodes.FRENCH] = 'Nous sommes désolés, une erreur réseau nous empêche de charger le questionnaire. Vous pouvez afficher la vidéo. Pour essayer de recharger le questionnaire, actualisez la page Web ou vérifiez la connexion réseau.';
   playerStrings.txtVideoQuizNetworkErrorMessage[languageCodes.SPANISH] = 'Lo lamentamos, un error de red ha impedido la carga del cuestionario. El vídeo sí está disponible para su visualización. Para intentar volver a cargar el cuestionario, actualice la página del navegador o compruebe la conexión de red.';
   playerStrings.txtVideoQuizNetworkErrorMessage[languageCodes.CHINESE] = '很抱歉，网络错误导致测验无法加载。该视频可供观看。要尝试重新加载测验，请刷新浏览器页面或检查您的网络连接。';

   playerStrings.txtImageQuizNetworkErrorMessage = {};
   playerStrings.txtImageQuizNetworkErrorMessage[languageCodes.ENGLISH] = 'We’re sorry, a network error has prevented the quiz from loading. The image is available to view. To try and reload the quiz, refresh the browser page or check your network connection.';
   playerStrings.txtImageQuizNetworkErrorMessage[languageCodes.GERMAN] = 'Leider hat ein Netzwerkfehler das Laden des Quiz verhindert. Das Bild kann angeschaut werden. Um das Quiz neu zu laden, aktualisieren Sie die Browser-Seite oder prüfen Sie Ihre Netzwerkverbindung.';
   playerStrings.txtImageQuizNetworkErrorMessage[languageCodes.JAPANESE] = '申し訳ありません。ネットワーク エラーによりクイズがロードされませんでした。画像は表示できます。クイズを再度ロードするには、ブラウザーのページを再読み込みするか、またはご使用のネットワーク接続を確認してください。';
   playerStrings.txtImageQuizNetworkErrorMessage[languageCodes.FRENCH] = 'Nous sommes désolés, une erreur réseau nous empêche de charger le questionnaire. Vous pouvez afficher l\'image. Pour essayer de recharger le questionnaire, actualisez la page Web ou vérifiez la connexion réseau.';
   playerStrings.txtImageQuizNetworkErrorMessage[languageCodes.SPANISH] = 'Lo lamentamos, un error de red ha impedido la carga del cuestionario. La imagen sí está disponible para su visualización. Para intentar volver a cargar el cuestionario, actualice la página del navegador o compruebe la conexión de red.';
   playerStrings.txtImageQuizNetworkErrorMessage[languageCodes.CHINESE] = '很抱歉，网络错误导致测验无法加载。该图片可供查看。要尝试重新加载测验，请刷新浏览器页面或检查您的网络连接。';

   playerStrings.txtQuizErrorMessage = {};
   playerStrings.txtQuizErrorMessage[languageCodes.ENGLISH] = 'We\'re attempting to save your response. Please make sure you have an active internet connection.';
   playerStrings.txtQuizErrorMessage[languageCodes.GERMAN] = 'Wir versuchen, Ihre Antworten zu speichern. Bitte achten Sie darauf, dass Sie eine aktive Internet Verbindung haben.';
   playerStrings.txtQuizErrorMessage[languageCodes.JAPANESE] = '返答の保存を試みています。インターネットに正しく接続しているか確認してください。';
   playerStrings.txtQuizErrorMessage[languageCodes.FRENCH] = 'Nous essayons d\'enregistrer votre réponse. Vérifiez que vous disposez d\'une connexion Internet active.';
   playerStrings.txtQuizErrorMessage[languageCodes.SPANISH] = 'Estamos intentando guardar su respuesta. Verifique que tiene conexión a Internet.';
   playerStrings.txtQuizErrorMessage[languageCodes.CHINESE] = '我们正在尝试保存您的回答。请确保您有有效的互联网连接。';

   playerStrings.txtQuizOutOfDateMessage = {};
   playerStrings.txtQuizOutOfDateMessage[languageCodes.ENGLISH] = 'The quiz questions have changed. Please refresh the player to get the latest quiz.';
   playerStrings.txtQuizOutOfDateMessage[languageCodes.GERMAN] = 'Die Quizfragen sind geändert worden. Bitte aktualisieren Sie den Player, damit das aktuelle Quiz angezeigt wird.';
   playerStrings.txtQuizOutOfDateMessage[languageCodes.JAPANESE] = 'クイズの質問が変更されました。最新のクイズを取得するには、Player を更新してください。';
   playerStrings.txtQuizOutOfDateMessage[languageCodes.FRENCH] = 'Les questions ont changé. Veuillez actualiser le lecteur pour accéder à la dernière version du questionnaire.';
   playerStrings.txtQuizOutOfDateMessage[languageCodes.SPANISH] = 'Las preguntas del cuestionario han cambiado. Actualiza el reproductor para ver el cuestionario más reciente.';
   playerStrings.txtQuizOutOfDateMessage[languageCodes.CHINESE] = '测验问题已更改。请刷新播放器以获取最新的测验。';

   playerStrings.txtQuizOutOfDateRefreshButtonText = {};
   playerStrings.txtQuizOutOfDateRefreshButtonText[languageCodes.ENGLISH] = 'Refresh Player';
   playerStrings.txtQuizOutOfDateRefreshButtonText[languageCodes.GERMAN] = 'Player aktualisieren';
   playerStrings.txtQuizOutOfDateRefreshButtonText[languageCodes.JAPANESE] = 'Player の更新';
   playerStrings.txtQuizOutOfDateRefreshButtonText[languageCodes.FRENCH] = 'Actualiser';
   playerStrings.txtQuizOutOfDateRefreshButtonText[languageCodes.SPANISH] = 'Actualizar el reproductor';
   playerStrings.txtQuizOutOfDateRefreshButtonText[languageCodes.CHINESE] = '刷新播放器';

   playerStrings.txtLoaderMessageDefinition = {};
   playerStrings.txtLoaderMessageDefinition[languageCodes.ENGLISH] = 'The quiz is loading.';
   playerStrings.txtLoaderMessageDefinition[languageCodes.GERMAN] = 'Das Quiz wird geladen.';
   playerStrings.txtLoaderMessageDefinition[languageCodes.JAPANESE] = 'クイズを読み込んでいます。';
   playerStrings.txtLoaderMessageDefinition[languageCodes.FRENCH] = 'Le questionnaire est en cours de chargement.';
   playerStrings.txtLoaderMessageDefinition[languageCodes.SPANISH] = 'El cuestionario se está cargando.';
   playerStrings.txtLoaderMessageDefinition[languageCodes.CHINESE] = '测验正在加载。';

   playerStrings.txtQuestionCount = {};
   playerStrings.txtQuestionCount[languageCodes.ENGLISH] = '{{currentQuestion}} of {{totalQuestions}}';
   playerStrings.txtQuestionCount[languageCodes.GERMAN] = '{{currentQuestion}} von {{totalQuestions}}';
   playerStrings.txtQuestionCount[languageCodes.JAPANESE] = '{{currentQuestion}} 問 ({{totalQuestions}} 問中)';
   playerStrings.txtQuestionCount[languageCodes.FRENCH] = '{{currentQuestion}} sur {{totalQuestions}}';
   playerStrings.txtQuestionCount[languageCodes.SPANISH] = '{{currentQuestion}} de {{totalQuestions}}';
   playerStrings.txtQuestionCount[languageCodes.CHINESE] = '{{currentQuestion}}/ {{totalQuestions}}';

   playerStrings.txtResults = {};
   playerStrings.txtResults[languageCodes.ENGLISH] = 'Results: ';
   playerStrings.txtResults[languageCodes.GERMAN] = 'Ergebnisse: ';
   playerStrings.txtResults[languageCodes.JAPANESE] = '結果: ';
   playerStrings.txtResults[languageCodes.FRENCH] = 'Résultats : ';
   playerStrings.txtResults[languageCodes.SPANISH] = 'Resultados: ';
   playerStrings.txtResults[languageCodes.CHINESE] = '结果：';

   playerStrings.txtCorrectString = {};
   playerStrings.txtCorrectString[languageCodes.ENGLISH] = 'Correct';
   playerStrings.txtCorrectString[languageCodes.GERMAN] = 'Richtig';
   playerStrings.txtCorrectString[languageCodes.JAPANESE] = '正解';
   playerStrings.txtCorrectString[languageCodes.FRENCH] = 'Correct';
   playerStrings.txtCorrectString[languageCodes.SPANISH] = 'Correcto';
   playerStrings.txtCorrectString[languageCodes.CHINESE] = '正确';

   playerStrings.txtIncorrectString = {};
   playerStrings.txtIncorrectString[languageCodes.ENGLISH] = 'Incorrect';
   playerStrings.txtIncorrectString[languageCodes.GERMAN] = 'Falsch';
   playerStrings.txtIncorrectString[languageCodes.JAPANESE] = '不正解';
   playerStrings.txtIncorrectString[languageCodes.FRENCH] = 'Incorrect';
   playerStrings.txtIncorrectString[languageCodes.SPANISH] = 'Incorrecto';
   playerStrings.txtIncorrectString[languageCodes.CHINESE] = '不正确';

   playerStrings.txtCorrect = {};
   playerStrings.txtCorrect[languageCodes.ENGLISH] = '{{numberCorrect}} Correct';
   playerStrings.txtCorrect[languageCodes.GERMAN] = '{{numberCorrect}} Richtig';
   playerStrings.txtCorrect[languageCodes.JAPANESE] = '正解 {{numberCorrect}}';
   playerStrings.txtCorrect[languageCodes.FRENCH] = '{{numberCorrect}} Correct';
   playerStrings.txtCorrect[languageCodes.SPANISH] = '{{numberCorrect}} respuestas correctas';
   playerStrings.txtCorrect[languageCodes.CHINESE] = '{{numberCorrect}}正确';

   playerStrings.txtIncorrect = {};
   playerStrings.txtIncorrect[languageCodes.ENGLISH] = '{{numberIncorrect}} Incorrect';
   playerStrings.txtIncorrect[languageCodes.GERMAN] = '{{numberIncorrect}} Falsch';
   playerStrings.txtIncorrect[languageCodes.JAPANESE] = '不正解 {{numberIncorrect}}';
   playerStrings.txtIncorrect[languageCodes.FRENCH] = '{{numberIncorrect}} Incorrect';
   playerStrings.txtIncorrect[languageCodes.SPANISH] = '{{numberIncorrect}} respuestas incorrectas';
   playerStrings.txtIncorrect[languageCodes.CHINESE] = '{{numberIncorrect}}不正确';

   playerStrings.txtYourAnswer = {};
   playerStrings.txtYourAnswer[languageCodes.ENGLISH] = '. Your answer: ';
   playerStrings.txtYourAnswer[languageCodes.GERMAN] = '. Ihre Antwort: ';
   playerStrings.txtYourAnswer[languageCodes.JAPANESE] = '. 解答/回答: ';
   playerStrings.txtYourAnswer[languageCodes.FRENCH] = '. Votre réponse : ';
   playerStrings.txtYourAnswer[languageCodes.SPANISH] = '. Su respuesta: ';
   playerStrings.txtYourAnswer[languageCodes.CHINESE] = '.您的答案：';

   playerStrings.txtCorrectAnswer = {};
   playerStrings.txtCorrectAnswer[languageCodes.ENGLISH] = '. Correct answer: ';
   playerStrings.txtCorrectAnswer[languageCodes.GERMAN] = '. Richtige Antwort: ';
   playerStrings.txtCorrectAnswer[languageCodes.JAPANESE] = '. 正解: ';
   playerStrings.txtCorrectAnswer[languageCodes.FRENCH] = '. Réponse correcte : ';
   playerStrings.txtCorrectAnswer[languageCodes.SPANISH] = '. Respuesta correcta: ';
   playerStrings.txtCorrectAnswer[languageCodes.CHINESE] = '.正确答案：';

   // accessibility --------------------------------------------------------------------------------
   playerStrings.accessBtnAudioDescription = {};
   playerStrings.accessBtnAudioDescription[languageCodes.ENGLISH] = 'Audio Description';
   playerStrings.accessBtnAudioDescription[languageCodes.GERMAN] = 'Audio-Beschreibung';
   playerStrings.accessBtnAudioDescription[languageCodes.JAPANESE] = '音声ガイド';
   playerStrings.accessBtnAudioDescription[languageCodes.FRENCH] = 'Description audio';
   playerStrings.accessBtnAudioDescription[languageCodes.SPANISH] = 'Descripción de audio';
   playerStrings.accessBtnAudioDescription[languageCodes.CHINESE] = '音频描述';

   playerStrings.accessBtnClearSearch = {};
   playerStrings.accessBtnClearSearch[languageCodes.ENGLISH] = 'Clear Search';
   playerStrings.accessBtnClearSearch[languageCodes.GERMAN] = 'Suche löschen';
   playerStrings.accessBtnClearSearch[languageCodes.JAPANESE] = '検索をクリア';
   playerStrings.accessBtnClearSearch[languageCodes.FRENCH] = 'Effacer la recherche';
   playerStrings.accessBtnClearSearch[languageCodes.SPANISH] = 'Borrar búsqueda';
   playerStrings.accessBtnClearSearch[languageCodes.CHINESE] = '清除搜索';

   playerStrings.accessBtnRewind = {};
   playerStrings.accessBtnRewind[languageCodes.ENGLISH] = 'Rewind';
   playerStrings.accessBtnRewind[languageCodes.GERMAN] = 'Zurückspulen';
   playerStrings.accessBtnRewind[languageCodes.JAPANESE] = '巻き戻し';
   playerStrings.accessBtnRewind[languageCodes.FRENCH] = 'Rembobiner';
   playerStrings.accessBtnRewind[languageCodes.SPANISH] = 'Retroceso';
   playerStrings.accessBtnRewind[languageCodes.CHINESE] = '倒回';

   playerStrings.accessBtnPlay = {};
   playerStrings.accessBtnPlay[languageCodes.ENGLISH] = 'Play Video';
   playerStrings.accessBtnPlay[languageCodes.GERMAN] = 'Video wiedergeben';
   playerStrings.accessBtnPlay[languageCodes.JAPANESE] = 'ビデオを再生する';
   playerStrings.accessBtnPlay[languageCodes.FRENCH] = 'Lire la vidéo';
   playerStrings.accessBtnPlay[languageCodes.SPANISH] = 'Reproducir vídeo';
   playerStrings.accessBtnPlay[languageCodes.CHINESE] = '播放视频';

   playerStrings.accessBtnPrevious = {};
   playerStrings.accessBtnPrevious[languageCodes.ENGLISH] = 'Previous';
   playerStrings.accessBtnPrevious[languageCodes.GERMAN] = 'Zurück';
   playerStrings.accessBtnPrevious[languageCodes.JAPANESE] = '前へ';
   playerStrings.accessBtnPrevious[languageCodes.FRENCH] = 'Précédent';
   playerStrings.accessBtnPrevious[languageCodes.SPANISH] = 'Anterior';
   playerStrings.accessBtnPrevious[languageCodes.CHINESE] = '上一个';

   playerStrings.accessBtnNext = {};
   playerStrings.accessBtnNext[languageCodes.ENGLISH] = 'Next';
   playerStrings.accessBtnNext[languageCodes.GERMAN] = 'Weiter';
   playerStrings.accessBtnNext[languageCodes.JAPANESE] = '次へ';
   playerStrings.accessBtnNext[languageCodes.FRENCH] = 'Suivant';
   playerStrings.accessBtnNext[languageCodes.SPANISH] = 'Siguiente';
   playerStrings.accessBtnNext[languageCodes.CHINESE] = '下一个';

   playerStrings.accessBtnProgressBar = {};
   playerStrings.accessBtnProgressBar[languageCodes.ENGLISH] = 'Progress bar slider';
   playerStrings.accessBtnProgressBar[languageCodes.GERMAN] = 'Fortschrittsbalken';
   playerStrings.accessBtnProgressBar[languageCodes.JAPANESE] = '進行状況バー スライダー';
   playerStrings.accessBtnProgressBar[languageCodes.FRENCH] = 'Curseur de progression';
   playerStrings.accessBtnProgressBar[languageCodes.SPANISH] = 'Control de barra de progreso';
   playerStrings.accessBtnProgressBar[languageCodes.CHINESE] = '进度滑块';

   playerStrings.accessBtnVolume = {};
   playerStrings.accessBtnVolume[languageCodes.ENGLISH] = 'Mute';
   playerStrings.accessBtnVolume[languageCodes.GERMAN] = 'Stumm';
   playerStrings.accessBtnVolume[languageCodes.JAPANESE] = 'ミュート';
   playerStrings.accessBtnVolume[languageCodes.FRENCH] = 'Désactiver le son';
   playerStrings.accessBtnVolume[languageCodes.SPANISH] = 'Silencio';
   playerStrings.accessBtnVolume[languageCodes.CHINESE] = '静音';

   playerStrings.accessTxtVolume = {};
   playerStrings.accessTxtVolume[languageCodes.ENGLISH] = 'Volume';
   playerStrings.accessTxtVolume[languageCodes.GERMAN] = 'Volumen';
   playerStrings.accessTxtVolume[languageCodes.JAPANESE] = '音量';
   playerStrings.accessTxtVolume[languageCodes.FRENCH] = 'Volume';
   playerStrings.accessTxtVolume[languageCodes.SPANISH] = 'Volumen';
   playerStrings.accessTxtVolume[languageCodes.CHINESE] = '音量';

   playerStrings.accessBtnClosedCaption = {};
   playerStrings.accessBtnClosedCaption[languageCodes.ENGLISH] = 'Closed Caption';
   playerStrings.accessBtnClosedCaption[languageCodes.GERMAN] = 'Geschlossene Beschriftung';
   playerStrings.accessBtnClosedCaption[languageCodes.JAPANESE] = 'クローズド キャプション';
   playerStrings.accessBtnClosedCaption[languageCodes.FRENCH] = 'Sous-titre activable';
   playerStrings.accessBtnClosedCaption[languageCodes.SPANISH] = 'Subtítulo';
   playerStrings.accessBtnClosedCaption[languageCodes.CHINESE] = '隐藏式字幕';

   playerStrings.accessBtnTableOfContents = {};
   playerStrings.accessBtnTableOfContents[languageCodes.ENGLISH] = 'Table of Contents (T)';
   playerStrings.accessBtnTableOfContents[languageCodes.GERMAN] = 'Inhaltsverzeichnis (I)';
   playerStrings.accessBtnTableOfContents[languageCodes.JAPANESE] = '目次 (T)';
   playerStrings.accessBtnTableOfContents[languageCodes.FRENCH] = 'Sommaire (T)';
   playerStrings.accessBtnTableOfContents[languageCodes.SPANISH] = 'Índice (T)';
   playerStrings.accessBtnTableOfContents[languageCodes.CHINESE] = '目录 (T)';

   playerStrings.accessBtnSettings = {};
   playerStrings.accessBtnSettings[languageCodes.ENGLISH] = 'Player Settings';
   playerStrings.accessBtnSettings[languageCodes.GERMAN] = 'Einstellungen';
   playerStrings.accessBtnSettings[languageCodes.JAPANESE] = 'プレーヤー設定';
   playerStrings.accessBtnSettings[languageCodes.FRENCH] = 'Paramètres du Player';
   playerStrings.accessBtnSettings[languageCodes.SPANISH] = 'Ajustes del reproductor';
   playerStrings.accessBtnSettings[languageCodes.CHINESE] = '播放器设置';

   playerStrings.accessBtnPip = {};
   playerStrings.accessBtnPip[languageCodes.ENGLISH] = 'Picture-in-Picture';
   playerStrings.accessBtnPip[languageCodes.GERMAN] = 'PIP';
   playerStrings.accessBtnPip[languageCodes.JAPANESE] = 'Picture-In-Picture';
   playerStrings.accessBtnPip[languageCodes.FRENCH] = 'Incrustation d’images';
   playerStrings.accessBtnPip[languageCodes.SPANISH] = 'Imagen dentro de imagen';
   playerStrings.accessBtnPip[languageCodes.CHINESE] = '画中画';

   playerStrings.accessBtnFullScreen = {};
   playerStrings.accessBtnFullScreen[languageCodes.ENGLISH] = 'Full Screen';
   playerStrings.accessBtnFullScreen[languageCodes.GERMAN] = 'Vollbild';
   playerStrings.accessBtnFullScreen[languageCodes.JAPANESE] = '全画面';
   playerStrings.accessBtnFullScreen[languageCodes.FRENCH] = 'Plein écran';
   playerStrings.accessBtnFullScreen[languageCodes.SPANISH] = 'Pantalla completa';
   playerStrings.accessBtnFullScreen[languageCodes.CHINESE] = '全屏';

   playerStrings.accessBtnFullScreenExpand = {};
   playerStrings.accessBtnFullScreenExpand[languageCodes.ENGLISH] = 'Open in new tab';
   playerStrings.accessBtnFullScreenExpand[languageCodes.GERMAN] = 'In neuem Tab öffnen';
   playerStrings.accessBtnFullScreenExpand[languageCodes.JAPANESE] = '新しいタブで開く';
   playerStrings.accessBtnFullScreenExpand[languageCodes.FRENCH] = 'Ouvrir dans un nouvel onglet';
   playerStrings.accessBtnFullScreenExpand[languageCodes.SPANISH] = 'Abrir en una nueva pestaña';
   playerStrings.accessBtnFullScreenExpand[languageCodes.CHINESE] = '在新选项卡中打开';

   playerStrings.accessBtnTakeQuiz = {};
   playerStrings.accessBtnTakeQuiz[languageCodes.ENGLISH] = 'Click to take the quiz.';
   playerStrings.accessBtnTakeQuiz[languageCodes.GERMAN] = 'Klicken Sie hier, um die Quizfragen zu beantworten.';
   playerStrings.accessBtnTakeQuiz[languageCodes.JAPANESE] = 'クリックしてクイズに答える。';
   playerStrings.accessBtnTakeQuiz[languageCodes.FRENCH] = 'Cliquez pour répondre au questionnaire.';
   playerStrings.accessBtnTakeQuiz[languageCodes.SPANISH] = 'Pulse para responder al cuestionario.';
   playerStrings.accessBtnTakeQuiz[languageCodes.CHINESE] = '单击以参加测验。';

   playerStrings.accessBtnShowQuiz = {};
   playerStrings.accessBtnShowQuiz[languageCodes.ENGLISH] = 'Show Quiz';
   playerStrings.accessBtnShowQuiz[languageCodes.GERMAN] = 'Quiz anzeigen';
   playerStrings.accessBtnShowQuiz[languageCodes.JAPANESE] = 'クイズの表示';
   playerStrings.accessBtnShowQuiz[languageCodes.FRENCH] = 'Afficher le questionnaire';
   playerStrings.accessBtnShowQuiz[languageCodes.SPANISH] = 'Mostrar cuestionario';
   playerStrings.accessBtnShowQuiz[languageCodes.CHINESE] = '显示测验';

   playerStrings.accessBtnHideQuiz = {};
   playerStrings.accessBtnHideQuiz[languageCodes.ENGLISH] = 'Hide Quiz';
   playerStrings.accessBtnHideQuiz[languageCodes.GERMAN] = 'Quiz ausblenden';
   playerStrings.accessBtnHideQuiz[languageCodes.JAPANESE] = 'クイズの非表示';
   playerStrings.accessBtnHideQuiz[languageCodes.FRENCH] = 'Masquer le questionnaire';
   playerStrings.accessBtnHideQuiz[languageCodes.SPANISH] = 'Ocultar cuestionario';
   playerStrings.accessBtnHideQuiz[languageCodes.CHINESE] = '隐藏测验';

   playerStrings.accessBtnShowAnswer = {};
   playerStrings.accessBtnShowAnswer[languageCodes.ENGLISH] = 'Show Answers';
   playerStrings.accessBtnShowAnswer[languageCodes.GERMAN] = 'Antworten anzeigen';
   playerStrings.accessBtnShowAnswer[languageCodes.JAPANESE] = '解答・回答の表示';
   playerStrings.accessBtnShowAnswer[languageCodes.FRENCH] = 'Afficher les réponses';
   playerStrings.accessBtnShowAnswer[languageCodes.SPANISH] = 'Mostrar respuestas';
   playerStrings.accessBtnShowAnswer[languageCodes.CHINESE] = '显示答案';

   playerStrings.accessBtnHideAnswer = {};
   playerStrings.accessBtnHideAnswer[languageCodes.ENGLISH] = 'Hide Answers';
   playerStrings.accessBtnHideAnswer[languageCodes.GERMAN] = 'Antworten ausblenden';
   playerStrings.accessBtnHideAnswer[languageCodes.JAPANESE] = '解答・回答の非表示';
   playerStrings.accessBtnHideAnswer[languageCodes.FRENCH] = 'Masquer les réponses';
   playerStrings.accessBtnHideAnswer[languageCodes.SPANISH] = 'Ocultar respuestas';
   playerStrings.accessBtnHideAnswer[languageCodes.CHINESE] = '隐藏答案';

   playerStrings.accessBtnAnswersSubmitted = {};
   playerStrings.accessBtnAnswersSubmitted[languageCodes.ENGLISH] = 'Answers Submitted!';
   playerStrings.accessBtnAnswersSubmitted[languageCodes.GERMAN] = 'Antworten wurden übermittelt!';
   playerStrings.accessBtnAnswersSubmitted[languageCodes.JAPANESE] = '解答・回答を送信しました!';
   playerStrings.accessBtnAnswersSubmitted[languageCodes.FRENCH] = 'Réponses envoyées.';
   playerStrings.accessBtnAnswersSubmitted[languageCodes.SPANISH] = '¡Respuestas enviadas!';
   playerStrings.accessBtnAnswersSubmitted[languageCodes.CHINESE] = '答案已提交！';

   playerStrings.accessBtnWereNotGraded = {};
   playerStrings.accessBtnWereNotGraded[languageCodes.ENGLISH] = ' were not graded.';
   playerStrings.accessBtnWereNotGraded[languageCodes.GERMAN] = ' wurden nicht bewertet.';
   playerStrings.accessBtnWereNotGraded[languageCodes.JAPANESE] = ' スコアに含まれない質問。';
   playerStrings.accessBtnWereNotGraded[languageCodes.FRENCH] = ' n\'ont pas été notées.';
   playerStrings.accessBtnWereNotGraded[languageCodes.SPANISH] = ' no han sido calificadas.';
   playerStrings.accessBtnWereNotGraded[languageCodes.CHINESE] = ' 未分级。';

   playerStrings.accessBtnWasNotGraded = {};
   playerStrings.accessBtnWasNotGraded[languageCodes.ENGLISH] = ' was not graded.';
   playerStrings.accessBtnWasNotGraded[languageCodes.GERMAN] = ' wurden nicht bewertet.';
   playerStrings.accessBtnWasNotGraded[languageCodes.JAPANESE] = ' スコアに含まれない質問。';
   playerStrings.accessBtnWasNotGraded[languageCodes.FRENCH] = ' n\'a pas été notée.';
   playerStrings.accessBtnWasNotGraded[languageCodes.SPANISH] = ' no ha sido calificada.';
   playerStrings.accessBtnWasNotGraded[languageCodes.CHINESE] = ' 未分级。';

   playerStrings.accessBtnCorrectOutOf = {};
   playerStrings.accessBtnCorrectOutOf[languageCodes.ENGLISH] = ' correct out of ';
   playerStrings.accessBtnCorrectOutOf[languageCodes.GERMAN] = ' korrekte Antworten von ';
   playerStrings.accessBtnCorrectOutOf[languageCodes.JAPANESE] = ' 問中 ';
   playerStrings.accessBtnCorrectOutOf[languageCodes.FRENCH] = ' « Correct » sur ';
   playerStrings.accessBtnCorrectOutOf[languageCodes.SPANISH] = ' correcta(s) de ';
   playerStrings.accessBtnCorrectOutOf[languageCodes.CHINESE] = ' 正确答案比例';

   playerStrings.accessBtnGradedQuestions = {};
   playerStrings.accessBtnGradedQuestions[languageCodes.ENGLISH] = ' graded questions.';
   playerStrings.accessBtnGradedQuestions[languageCodes.GERMAN] = ' bewerteten Antworten.';
   playerStrings.accessBtnGradedQuestions[languageCodes.JAPANESE] = ' スコアに含まれる質問。';
   playerStrings.accessBtnGradedQuestions[languageCodes.FRENCH] = ' questions notées.';
   playerStrings.accessBtnGradedQuestions[languageCodes.SPANISH] = ' preguntas calificadas.';
   playerStrings.accessBtnGradedQuestions[languageCodes.CHINESE] = ' 已分级问题。';

   playerStrings.accessBtnClickToReplayLink = {};
   playerStrings.accessBtnClickToReplayLink[languageCodes.ENGLISH] = 'Replay';
   playerStrings.accessBtnClickToReplayLink[languageCodes.GERMAN] = 'Wiederholen';
   playerStrings.accessBtnClickToReplayLink[languageCodes.JAPANESE] = '再生';
   playerStrings.accessBtnClickToReplayLink[languageCodes.FRENCH] = 'Relire';
   playerStrings.accessBtnClickToReplayLink[languageCodes.SPANISH] = 'Reproducir';
   playerStrings.accessBtnClickToReplayLink[languageCodes.CHINESE] = '重播';

   playerStrings.scormApiNotFoundMessage = {};
   playerStrings.scormApiNotFoundMessage[languageCodes.ENGLISH] = 'Unable to locate the LMS\'s API Implementation.\nCommunication with the LMS will not occur.';
   playerStrings.scormApiNotFoundMessage[languageCodes.GERMAN] = 'Die API-Implementierung des LMS-Systems kann nicht gefunden werden.\nDie Kommunikation mit dem LMS-System kann nicht hergestellt werden.';
   playerStrings.scormApiNotFoundMessage[languageCodes.JAPANESE] = 'LMS の API 実装が見つかりません\nLMS とコミュニケーションできません';
   playerStrings.scormApiNotFoundMessage[languageCodes.FRENCH] = 'Impossible de localiser l\'implémentation API du LMS.\nLa communication avec le LMS sera impossible.';
   playerStrings.scormApiNotFoundMessage[languageCodes.SPANISH] = 'No es posible localizar la implementación de la API de LMS.\nNo se establecerá ninguna conexión con LMS.';
   playerStrings.scormApiNotFoundMessage[languageCodes.CHINESE] = '无法找到 LMS 的 API Implementation。\n不会发生与 LMS 的通信。';

   playerStrings.accessListTableOfContents = {};
   playerStrings.accessListTableOfContents[languageCodes.ENGLISH] = 'Table of contents';
   playerStrings.accessListTableOfContents[languageCodes.GERMAN] = 'Inhaltsverzeichnis';
   playerStrings.accessListTableOfContents[languageCodes.JAPANESE] = '目次';
   playerStrings.accessListTableOfContents[languageCodes.FRENCH] = 'Sommaire';
   playerStrings.accessListTableOfContents[languageCodes.SPANISH] = 'Índice';
   playerStrings.accessListTableOfContents[languageCodes.CHINESE] = '目录';

   playerStrings.accessListSearchResults = {};
   playerStrings.accessListSearchResults[languageCodes.ENGLISH] = 'Search results in order of appearance';
   playerStrings.accessListSearchResults[languageCodes.GERMAN] = 'Suchergebnisse nach Zeitpunkt der Anzeige';
   playerStrings.accessListSearchResults[languageCodes.JAPANESE] = '検索結果 (出現順)';
   playerStrings.accessListSearchResults[languageCodes.FRENCH] = 'Résultats de la recherche par ordre d\'affichage';
   playerStrings.accessListSearchResults[languageCodes.SPANISH] = 'Resultados de la búsqueda en orden de aparición';
   playerStrings.accessListSearchResults[languageCodes.CHINESE] = '按外观顺序搜索结果';

   playerStrings.accessListNoSearchResults = {};
   playerStrings.accessListNoSearchResults[languageCodes.ENGLISH] = 'No results found';
   playerStrings.accessListNoSearchResults[languageCodes.GERMAN] = 'Keine Ergebnisse gefunden';
   playerStrings.accessListNoSearchResults[languageCodes.JAPANESE] = '結果が見つかりません';
   playerStrings.accessListNoSearchResults[languageCodes.FRENCH] = 'Aucun résultat';
   playerStrings.accessListNoSearchResults[languageCodes.SPANISH] = 'No se encontró ningún resultado';
   playerStrings.accessListNoSearchResults[languageCodes.CHINESE] = '未找到结果';

   playerStrings.accessQuestionSetConfirmationTitle = {};
   playerStrings.accessQuestionSetConfirmationTitle[languageCodes.ENGLISH] = 'Quiz';
   playerStrings.accessQuestionSetConfirmationTitle[languageCodes.GERMAN] = 'Quiz';
   playerStrings.accessQuestionSetConfirmationTitle[languageCodes.JAPANESE] = 'クイズ';
   playerStrings.accessQuestionSetConfirmationTitle[languageCodes.FRENCH] = 'Questionnaire';
   playerStrings.accessQuestionSetConfirmationTitle[languageCodes.SPANISH] = 'Cuestionario';
   playerStrings.accessQuestionSetConfirmationTitle[languageCodes.CHINESE] = '测验';

   playerStrings.accessVideoPausedForQuiz = {};
   playerStrings.accessVideoPausedForQuiz[languageCodes.ENGLISH] = 'Video paused for quiz';
   playerStrings.accessVideoPausedForQuiz[languageCodes.GERMAN] = 'Video wird angehalten - es folgt ein Quiz';
   playerStrings.accessVideoPausedForQuiz[languageCodes.JAPANESE] = 'クイズの場所でビデオを一時停止しました';
   playerStrings.accessVideoPausedForQuiz[languageCodes.FRENCH] = 'Vidéo sur pause pour le questionnaire';
   playerStrings.accessVideoPausedForQuiz[languageCodes.SPANISH] = 'Vídeo en pausa para el cuestionario';
   playerStrings.accessVideoPausedForQuiz[languageCodes.CHINESE] = '视频因测验而暂停';

   playerStrings.accessQuizResults = {};
   playerStrings.accessQuizResults[languageCodes.ENGLISH] = 'Quiz results';
   playerStrings.accessQuizResults[languageCodes.GERMAN] = 'Quizergebnisse';
   playerStrings.accessQuizResults[languageCodes.JAPANESE] = 'クイズの結果';
   playerStrings.accessQuizResults[languageCodes.FRENCH] = 'Résultats du questionnaire';
   playerStrings.accessQuizResults[languageCodes.SPANISH] = 'Resultados del cuestionario';
   playerStrings.accessQuizResults[languageCodes.CHINESE] = '测验结果';

   var setLanguage = function(language) {
      if (languageCodes.isValid(language)) {
         _language = language;
      }
   };

   var getLanguage = function() {
      return _language;
   };

   var getLanguageNameFromIdentifierString = function(languageIdentifierString) {
      var languageIdentifier = tscme.LanguageIdentifier.create(languageIdentifierString);
      return tscme.languageIdentifiers.identifiers[languageIdentifier.language] ? tscme.languageIdentifiers.identifiers[languageIdentifier.language].displayName : languageIdentifierString;
   };

   var setString = function(stringLabel, stringValue) {
      if (playerStrings[stringLabel] !== undefined) {
         playerStrings[stringLabel][_language] = stringValue;
      } else {
         throw new Error('setString(): \'' + stringLabel + '\' string does not exist in the player.');
      }
   };

   var getQuestionCountPreposition = function() {
      if (!_prepositionText) {
         var parts = playerStrings.txtQuestionCount[_language].split(' ');
         for (var i = 0; i < parts.length; i++) {
            if (parts[i].indexOf('{{') === -1) {
               _prepositionText = parts[i];
               break;
            }
         }
      }
      return _prepositionText;
   };

   var configureLanguageFromXmp = function(xmp) {
      xmp.controllerParameters.forEach(function(controllerParameter) {
         switch (controllerParameter.name.toLowerCase()) {
            case 'locale':
               setLanguage(controllerParameter.value);
               break;
         }
      });
   };

   var configureCustomStringsFromXmp = function(xmp) {
      xmp.quizParameters.forEach(function(quizParameter) {
         try {
            setString(quizParameter.name, quizParameter.value);
         } catch (e) {
            log.logMessage(e.message);
         }
      });
   };

   var configureFromXmp = function(xmp) {
      configureLanguageFromXmp(xmp); //Configure language first so that _language is properly set
      configureCustomStringsFromXmp(xmp);
   };

   var createStringExportObject = function() {
      _playerStringsExport = {};
      Object.keys(playerStrings).forEach(function(key) {
         Object.defineProperty(_playerStringsExport,
            key,
            {
               get: function() {
                  return playerStrings[key][_language];
               }
            });
      });
   };

   createStringExportObject();

   return Object.defineProperties({
      getLanguageNameFromIdentifierString: getLanguageNameFromIdentifierString,
      setLanguage: setLanguage,
      getLanguage: getLanguage,
      getQuestionCountPreposition: getQuestionCountPreposition,
      configureFromXmp: configureFromXmp
   }, {
      strings: {
         get: function() {
            return _playerStringsExport;
         }
      }
   });
});

